import { render } from "./TicketsbyRemark.vue?vue&type=template&id=3f6f8a1f"
import script from "./TicketsbyRemark.vue?vue&type=script&lang=js"
export * from "./TicketsbyRemark.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__